module.exports = __webpack_public_path__ + "img/truck-container-empty.ae28d069.svg";